import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { USER_PIN_LENGTH, USER_PIN_MASK } from '../../shared/models/user/user.constants';

/**
 * Validates a kiosk PIN as exactly four numeric digits.
 *
 * @param {boolean} isRequired - Whether an empty value should fail validation.
 * @return {ValidatorFn} Validator function for PIN controls.
 */
export function pinValidator(isRequired: boolean = true): ValidatorFn {
	const pinPattern = new RegExp(`^\\d{${USER_PIN_LENGTH}}$`);

	return (control: AbstractControl): ValidationErrors | null => {
		const value = control.value as string;
		if (!value || value === USER_PIN_MASK) {
			return isRequired ? { pinFormat: true } : null;
		}

		return pinPattern.test(value) ? null : { pinFormat: true };
	};
}
